export function getLastYearsNames(count) {
  const currentYear = new Date().getFullYear(); // Get the current year
  const years = [];

  for (let i = 0; i < count; i++) {
    years.push(currentYear - i);
  }

  return years.reverse(); // Reverse to get the correct order
}
